<div class="container">

  <app-header-dialog [iconName]="'flare'">
    Tópico
  </app-header-dialog>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !_topicService.spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div class='bread-crumb' flex>
    <mat-icon color="accent">arrow_right</mat-icon> {{ _topicService.breadCrumb(_topicService.currentEvent.name) }}
    <mat-icon color="accent">arrow_right</mat-icon> {{ _topicService.breadCrumb(_topicService.currentDay.name) }}
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _topicService.breadCrumb(_topicService.currentActivity.name) }}
    <mat-icon color="accent">arrow_right</mat-icon> {{ _topicService.breadCrumb(_topicService.localTitle) }}
  </div>



  <form class="form" name="topicForm" [formGroup]='topicForm' autocomplete="off">

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>flare</mat-icon>
          <div>Tópico</div>
        </ng-template>

        <div class='tab-content'>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="topicForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="topicForm.controls.name.hasError('required')">
              O Nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="time-width" appearance="outline">
            <mat-label>Hora</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="topicForm.controls.startTime"
              autocomplete="off">
            <mat-error *ngIf="topicForm.controls.startTime.hasError('required')">
              O Início é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="time-width" appearance="outline">
            <mat-label>Duração</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="topicForm.controls.duration"
              autocomplete="off">
            <mat-error *ngIf="topicForm.controls.duration.hasError('required')">
              A duração é obrigatória
            </mat-error>
          </mat-form-field>

          <mat-form-field class="date-width" appearance="outline">
            <mat-label>Data</mat-label>
            <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
              [formControl]="topicForm.controls.date" readonly>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker disabled></mat-datepicker>
            <mat-error *ngIf="topicForm.controls.date.hasError('required')">
              A data é obrigatoria
            </mat-error>
          </mat-form-field>


          <mat-tab-group style='margin:0; padding: 0;'>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class='tab-icon'>text_fields</mat-icon>
                <div>Apresentação</div>
              </ng-template>

              <ckeditor [config]="{ 
                                toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
                [formControl]="topicForm.controls.text" [editor]="Editor"></ckeditor>
              <mat-error *ngIf="topicForm.controls.text.hasError('required')">
                O Texto é obrigatório
              </mat-error>

            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class='tab-icon'>text_fields</mat-icon>
                <div>Certificado 1</div>
              </ng-template>

              <mat-form-field class="full-width" appearance="outline">
                <textarea class='text-cert-area' matInput [errorStateMatcher]="matcher"
                  [formControl]="topicForm.controls.text1" autocomplete="off">
                            </textarea>
              </mat-form-field>

            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class='tab-icon'>text_fields</mat-icon>
                <div>Certificado 2</div>
              </ng-template>

              <mat-form-field class="full-width" appearance="outline">
                <textarea class='text-cert-area' matInput [errorStateMatcher]="matcher" placeholder=""
                  [formControl]="topicForm.controls.text2" autocomplete="off">
                            </textarea>
              </mat-form-field>

            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class='tab-icon'>text_fields</mat-icon>
                <div>Certificado 3</div>
              </ng-template>

              <mat-form-field class="full-width" appearance="outline">
                <textarea class='text-cert-area' matInput [errorStateMatcher]="matcher" placeholder=""
                  [formControl]="topicForm.controls.text3" autocomplete="off">
                            </textarea>
              </mat-form-field>

            </mat-tab>

          </mat-tab-group>

        </div>
        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
          <button mat-raised-button (click)='insert()' [disabled]="topicForm.invalid" *ngIf="!_topicService.isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
          <button mat-raised-button (click)='update()' [disabled]="topicForm.invalid" *ngIf="_topicService.isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>

      </mat-tab>

      <mat-tab *ngIf='_topicService.isEdit'>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>people</mat-icon>
          <div>Equipe</div>
        </ng-template>

        <div class='tab-content-roles'>

          <!-- TABLE -->
          <mat-table [dataSource]="agendaTopicDataSource" matSort matSortActive="role_name"
            style=' height: calc(100vh - 320px); overflow:auto; margin: 10px 0 0 0;'>

            <!-- Name Column -->
            <ng-container matColumnDef="member_name">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Colaborador </mat-header-cell>
              <mat-cell *matCellDef="let element">

                <div style='padding:5px;' flex fxLayout="column" fxLayoutAlign="start start">

                  <div class='item-agenda-role'>
                    {{ element.member_name }} - ({{ element.member_state }})
                  </div>

                  <div class='item-agenda' *ngIf='!element.dateConfirmed'>
                    <div class='item-agenda-label'>Confirmar:</div>
                    <div class='item-agenda-data'>
                      <span *ngIf='element.requireConfirm'>Sim</span>
                      <span *ngIf='!element.requireConfirm'>Não</span>
                    </div>
                  </div>

                  <div class='item-agenda' *ngIf='element.dateConfirmed'>
                    <div class='item-agenda-label'>Confirmado:</div>
                    <div class='item-agenda-data'>
                      {{ element.confirmed.seconds*1000 | date:'dd/MM/yyyy'}}
                    </div>
                  </div>

                </div>

              </mat-cell>

            </ng-container>

            <!-- Agenda Column -->
            <ng-container matColumnDef="role_name">
              <mat-header-cell *matHeaderCellDef> Agenda </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div style='padding:5px;' flex fxLayout="column" fxLayoutAlign="start start">

                  <div class='item-agenda-role'>
                    {{ element.role_name }}
                  </div>

                  <div class='item-agenda'>
                    <div class='item-agenda-label'>{{ element.day_date.seconds*1000 | date:
                      'dd/MM/yyyy'}}: </div>
                    <div class='item-agenda-data'>{{ element.day_name }}</div>
                  </div>

                  <div class='item-agenda'>
                    <div class='item-agenda-label'>Depto:</div>
                    <div class='item-agenda-data'>{{ element.depto_name }}</div>
                  </div>

                  <div class='item-agenda'>
                    <div class='item-agenda-label'>Atividade:</div>
                    <div class='item-agenda-data'>{{ element.activity_startTime }}
                      - {{ element.activity_name }}</div>
                  </div>

                  <div class='item-agenda'>
                    <div class='item-agenda-label'>Tópico:</div>
                    <div class='item-agenda-data'>{{ element.topic_startTime }}
                      - {{ element.topic_name }}</div>
                  </div>


                </div>
              </mat-cell>
            </ng-container>


            <!-- edit Column -->
            <ng-container matColumnDef="button_edit">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a (click)='openStaffDialog(element)' style='cursor:pointer;'>
                  <mat-icon class="icon-info">
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- delete Column -->
            <ng-container matColumnDef="button_delete">
              <mat-header-cell *matHeaderCellDef>
                <a mat-button (click)="openStaffDialog(null)">
                  <mat-icon class="icon-add">add_circle_outline</mat-icon>
                </a>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a (click)='_agendaService.removeAgenda(element)' style='cursor:pointer;'>
                  <mat-icon class='icon-delete'>
                    delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>
            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedAgendaColumns"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedAgendaColumns;">
            </mat-row>

          </mat-table>
          <!-- END TABLE -->


        </div>

      </mat-tab>

      <mat-tab *ngIf="false">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>picture_as_pdf</mat-icon>
          <div>PDFs</div>
        </ng-template>

        <div class='tab-content-pdf'>
          <mat-form-field class="full-width" appearance="outline">
            <label>Nome do Material</label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="pdfForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="pdfForm.controls.name.hasError('required')">
              O Nome para o material é obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <input #file type="file" accept='.*' style='display:none' (change)="selectFile($event)" />

        <div class="actions" fxLayoutAlign="space-between" flex justify-content='space-between'>
          <button mat-raised-button (click)='file.click()'>
            <mat-icon class='icon-add'>attachment</mat-icon>
          </button>

          <div style="text-align: left; color:rgba(0,0,0, .6); margin:10px 0 0 20px; width:100%;">
            {{pdfForm.controls.original.value}}
          </div>

          <button mat-raised-button (click)='uploadMaterial()' [disabled]="pdfForm.invalid">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>



        <!-- TABLE -->
        <mat-table [dataSource]="_topicService.pdfDataSource" matSort matSortActive="name"
          style='height:280px; overflow:auto; margin: 0;'>

          <!-- icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>person</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
          </ng-container>

          <!-- download Column -->
          <ng-container matColumnDef="download">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='goToLink(element.storage)' style='background-color: whitesmoke;'>
                <mat-icon style='font-size:1.5em; color:rgba(0,0,0,.6);'>
                  save_alt
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='removeMaterial(element)' style='background-color: whitesmoke;'>
                <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedPdfColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedPdfColumns;">
          </mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-tab>

      <mat-tab *ngIf='_topicService.isEdit && _topicService.currentEvent.control_ticket_by_topic'>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>playlist_add</mat-icon>
          <div>Vagas</div>
        </ng-template>


        <div class='tab-content'>

          <!-- TABLE -->
          <mat-table [dataSource]="_slotService.slotDataSource"
            style='height: calc(100vh - 360px); overflow:auto; margin: 0;'>

            <!-- icon Column -->
            <ng-container matColumnDef="icon">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>playlist_add</mat-icon>
              </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.name }} </mat-cell>
            </ng-container>

            <!-- qtd Column -->
            <ng-container matColumnDef="slot_qtd">
              <mat-header-cell *matHeaderCellDef> Qtd </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.slot_quantity }} </mat-cell>
            </ng-container>

            <!-- qtd used Column -->
            <ng-container matColumnDef="slot_used">
              <mat-header-cell *matHeaderCellDef> Usado</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.slot_used }} </mat-cell>
            </ng-container>

            <!-- wait Column -->
            <ng-container matColumnDef="wait_qtd">
              <mat-header-cell *matHeaderCellDef> Espera </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.slot_wait }} </mat-cell>
            </ng-container>

            <!-- wait used Column -->
            <ng-container matColumnDef="wait_used">
              <mat-header-cell *matHeaderCellDef> Usado</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.slot_wait_used }} </mat-cell>
            </ng-container>


            <!-- edit Column -->
            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openSlotDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>


            <!-- delete Column -->
            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='deleteSlot(element)' style='background-color: whitesmoke;'>
                  <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedSlotsColumns">
            </mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedSlotsColumns;">
            </mat-row>

          </mat-table>
          <!-- END TABLE -->

        </div>


        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end' *ngIf="_topicService.isEdit">
          <button mat-raised-button (click)='openSlotDialog(null)'>
            <mat-icon class='icon-add'>add_circle_outline</mat-icon>
          </button>
        </div>

      </mat-tab>

      <mat-tab *ngIf='false'>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>people</mat-icon>
          <div>Apoio</div>
        </ng-template>

        <div class='tab-content'>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Patrocinador</mat-label>
            <mat-select (ngModelChange)='sponsorSelected($event)' [errorStateMatcher]="matcher"
              [formControl]="topicForm.controls.sponsor_id">
              <mat-option *ngFor="let sponsor of allSponsors" [value]="sponsor.id">
                {{ sponsor.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div style='height: 320px;'>
            <div class='img-input'>
              <input #file_banner type="file" accept='image/png, image/jpg' style='display:none'
                (change)="_topicService.previewBannerTopic($event)" />
            </div>
            <div class="post-image">
              <img [src]="_topicService.storedBannerTopic" *ngIf="_topicService.storedBannerTopic">
            </div>
            <div class="button-image">
              <button mat-raised-button (click)='file_banner.click()'>
                <mat-icon class='icon-add'>image_search</mat-icon>
              </button>
            </div>

          </div>

        </div>

        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
          <button mat-raised-button
            [disabled]='!topicForm.controls.sponsor_id.value || !_topicService.objectBannerTopic'
            (click)='updateBannerTopic()'>
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

</div>